import React, { ReactElement, memo, useMemo } from "react";
import PageLayout from "../../PageLayout";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { saveRequest } from "../../../store/hashedHotCard/actions";
import { Formik } from "formik";
import { useHistory, useParams } from "react-router-dom";
import schema from "./HashedHotCard.schema";
import pageStyles from "../../pageStyles";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import TextInput from "../../../common/formElements/TextInput";
import { useToastMessage } from "../../../effects/useToastMessage";
import { toast } from "react-toastify";
import { getById } from "../../../store/hashedHotCard/queries";
import { HashedHotCard } from "../../../store/hashedHotCard/types";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

const HotCardEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;
  const title = useMemo(() => (mode === UPDATE ? "Edit HotCard" : "Add HotCard"), [mode]);
  
  const HotCard = useSelector(id ? getById(id) : () => ({ attributes: {} })) || { attributes: {} };

  const onCancel = () => history.push("/hotcard");

  const onSubmit = (values) => {
    const callback = (err: string | null, data: HashedHotCard | null) => {
      if (err) {
        toast.error(`An error occurred while saving: ${err}`, { closeOnClick: true });
      } else {
        if (mode === CREATE) {
          history.goBack();
        } else {
          toast.success("Saved successfully!", { closeOnClick: true });
        }
      }
    };
    dispatch(saveRequest({ id, ...values }, callback));
  };

  return (
    <PageLayout heading={title}>
      <Formik
        initialValues={HotCard.attributes}
        validationSchema={schema}
        onSubmit={onSubmit}
        onReset={onCancel}
      >
        {({ handleSubmit, handleReset, isSubmitting, errors }) => {
          useToastMessage(isSubmitting, errors);
          return (
            <form onSubmit={handleSubmit} onReset={handleReset} className={classes.formWrapper}>
              <SectionWrapper title="HotCard">
                <SectionWrapper isChild title="HotCard Details">
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="Name" label="Name" disabled={mode === UPDATE} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="Salt" label="Salt" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="FullURL" label="Full URL" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="DeltaURL" label="Delta URL" />
                    </Grid>
                  </Grid>
                </SectionWrapper>
              </SectionWrapper>
              <FormSubmitButtons />
            </form>
          );
        }}
      </Formik>
    </PageLayout>
  );
};

export default memo(HotCardEdit);
